import { gql } from '@apollo/client';

import { StudentActivity } from '@ts-core/modules/activities/types';
import { studentActivityFragment } from '../fragments';

export interface DeleteActivityAnswerMutationVariables {
  courseId: string;
  activityId: string;
  answerId: string;
}

export interface DeleteActivityAnswerMutationResult {
  activity: StudentActivity;
}

export const deleteActivityAnswerMutation = gql`
  mutation DeleteActivityAnswerMutation($courseId: String!, $activityId: String!, $answerId: String!) {
    activity(courseId: $courseId, activityId: $activityId, answerId: $answerId)
      @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}/answers/{args.answerId}", method: "DELETE") {
      ...StudentActivity
    }
  }
  ${studentActivityFragment}
`;
